// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.mainArea[data-v-72d51d32]{\r\n z-index: 8;\r\n height:'300px';\r\n overflow:'scroll';\n}\ndiv.mainArea[data-v-72d51d32]::-webkit-scrollbar{\r\n    display:none;\n}\nbody[data-v-72d51d32]::-webkit-scrollbar{\r\n  display:none;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
